import React, { Fragment, useState, useEffect } from "react"
import { toast } from "react-toastify"
import { createOrEditVotacion } from "../../services/admin.service"
import {
	Modal,
	Form,
	Button,
	Row,
	Col,
	Card,
	ListGroup,
	InputGroup,
	FormControl
} from "react-bootstrap"
import Loader from "./../shared/Loader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { isEqual } from "lodash"
import Inputmask from "inputmask"
import { isValidRut, getTimeFromDate, formatDate, formatDateSaveDb } from "./../../utils"

const ModalFormPeriodo = props => {
	const {
		show,
		setShow,
		unidades,
		setVotaciones,
		votaciones,
		votacion = {},
		isEdit = false
	} = props
	const [loader, setLoader] = useState(false)
	const [dataForm, setDataForm] = useState({})

	const [candidatos, setCandidatos] = useState([])
	const [candidatoSelected, setCandidatoSelected] = useState("")

	const [tricelSelected, setTricelSelected] = useState("")
	const [triceles, setTriceles] = useState([])

	const handleSubmit = async e => {
		e.preventDefault()
		if (candidatos.length === 0) return toast.warning("Debe seleccionar candidatos")
		if (triceles.length === 0) return toast.warning("Debe conformar Tricel")
		if (noChangesEdit()) {
			toast.info("No se han hecho cambios")
			closeModal()
			return
		}
		const dataParsed = {
			...dataForm,
			desde: (dataForm.desde || formatDateSaveDb(votacion.desde)) + " " +(dataForm.desde_hora || getTimeFromDate(votacion.desde).slice(0,5))+":00",
			hasta: (dataForm.hasta || formatDateSaveDb(votacion.hasta)) + " " +(dataForm.hasta_hora || getTimeFromDate(votacion.hasta).slice(0,5))+":00",
			candidatos: candidatos.map(x => {
				return { nombre: x.nombre || x }
			}),
			tricel: triceles.map(x=>{
				return { run: x.toString().slice(0, x.length -1) }
			})
		}
		
		setLoader(true)

		const res = (await isEdit)
			? await createOrEditVotacion(dataParsed, votacion.id)
			: await createOrEditVotacion(dataParsed)


		if (res?.response === "success") {
			setVotaciones(res.data)
			toast.info(res.message || "Votación creada correctamente")
			closeModal()
		} else {
			toast.error(res?.message || "Error al crear votacion")
		} 
		setLoader(false)
	}

	const noChangesEdit = () => {
		if (Object.keys(votacion).length === 0) return false

		const nombre = document.getElementById("nombre").value
		const desde = document.getElementById("desde").value
		const hasta = document.getElementById("hasta").value
		const unidad = document.getElementById("unidad").value
		const desde_hora = document.getElementById("desde_hora").value
		const hasta_hora = document.getElementById("hasta_hora").value
		const candsNombresAct = votacion.candidatos.map(x => x.nombre)
		const candsNombresForm = candidatos.map(x => x.nombre || x)

		return (
			votacion.nombre === nombre &&
			formatDate(votacion.desde) === formatDate(desde) &&
			formatDate(votacion.hasta) === formatDate(hasta) &&
			getTimeFromDate(votacion.desde).slice(0,5) === desde_hora &&
			getTimeFromDate(votacion.hasta).slice(0,5) === hasta_hora &&
			votacion.unidad_id.toString() === unidad.toString() &&
			isEqual(candsNombresAct, candsNombresForm)
		)
	}

	const handleChange = e => {
		setDataForm({ ...dataForm, [e.target.name]: e.target.value })
	}

	///////////// CANDIDATOS
	const handleChangeCandidato = e => {
		setCandidatoSelected(e.target.value)
	}

	const addCandidato = () => {
		if (candidatoSelected.length === 0) return
		setCandidatos([...candidatos, candidatoSelected])
		setCandidatoSelected("")
		document.getElementById("inputCandidato").value = ""
	}

	const removeCandidato = candidato => {
		setCandidatos(candidatos.filter(x => x !== candidato))
	}

	/////////////// TRICEL
	const handleChangeTricel = e => {
		setTricelSelected(e.target.value)
	}

	const addTricel = () => {
		if (tricelSelected.length === 0) return
			if (!isValidRut(tricelSelected)) {
				return toast.warning("El Rut ingresado no es válido")
			}
		setTriceles([...triceles, tricelSelected])
		setTricelSelected("")
		document.getElementById("inputTricel").value = ""
	}

	const removeTricel = tricel => {
		setTriceles(triceles.filter(x => x !== tricel))
	}
	//////////////////////

	const setOptionsSelect = () => {
		return unidades?.map(x => {
			return (
				<option key={x.id} value={x.id}>
					{x.nombre}
				</option>
			)
		})
	}

	const closeModal = () => {
		setDataForm({})
		setShow(false)
		setCandidatos([])
		setCandidatoSelected("")
		setTriceles([])
		setTricelSelected("")
	}

		const setInputMask = () => {
			const maskConfigRut = {
				mask: "(9.999.999-K)|(99.999.999-K)",
				autoUnmask: true, //para que .val() devuelva sin mascara (sin puntos ni guion)
				keepStatic: true, //para que el formato de mascara mas corta se mantenga hasta que sea necesario el mas largo
				showMaskOnFocus: false, //oculta la mascara en focus
				showMaskOnHover: false, //oculta la mascara en hover
				definitions: {
				K: {
					validator: "[0-9|kK]",
					casing: "upper"
				}
			}
			}

			const inputMaskRut = new Inputmask("inputTricel", maskConfigRut)
			inputMaskRut.mask(document.getElementsByName("inputTricel")[0])
		}

		useEffect(() => {
			if(show){
				setInputMask()
			}
		}, [show])


	useEffect(() => {
		if (isEdit) {
			setCandidatos(votacion.candidatos)
			setTriceles(votacion.periodo_eleccions.map(x => x.run.toString()+x.dv))
		}
	}, [votacion])

	return (
		<Modal
			show={show}
			size="xl"
			onHide={() => closeModal()}
			backdrop="static"
			keyboard={false}
			className="text-center"
		>
			<Modal.Header closeButton>
				<Modal.Title>{isEdit ? "Editar" : "Crear nueva"} Votación</Modal.Title>
			</Modal.Header>
			<Form onSubmit={handleSubmit}>
				<Modal.Body className="px-2 py-4">
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iure earum optio a
					perspiciatis facere non sint incidunt veniam iste asperiores amet, itaque magnam
					<hr />
					<div className="px-5">
						<Form.Row>
							<Form.Group as={Col}>
								<Form.Label>Nombre Votación</Form.Label>
								<Form.Control
									id="nombre"
									name="nombre"
									type="text"
									defaultValue={votacion?.nombre || ""}
									required
									onChange={handleChange}
								/>
							</Form.Group>

							<Form.Group as={Col}>
								<Form.Label>Unidad</Form.Label>
								<Form.Control
									as="select"
									name="unidad"
									id="unidad"
									onChange={handleChange}
									required
									defaultValue={votacion?.unidad_id || ""}
								>
									<option value="" disabled>
										Seleccione
									</option>
									{setOptionsSelect()}
								</Form.Control>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group as={Col}>
								<Form.Label>Fecha inicio</Form.Label>
								<Form.Control
									name="desde"
									id="desde"
									type="date"
									onChange={handleChange}
									required
									defaultValue={votacion?.desde?.substr(0, 10) || ""}
								/>
							</Form.Group>
							<Form.Group as={Col}>
								<Form.Label>Hora Inicio</Form.Label>
								<Form.Control
									name="desde_hora"
									id="desde_hora"
									type="time"
									onChange={handleChange}
									required
									defaultValue={getTimeFromDate(votacion?.desde)?.slice(0,5) || ""}
								/>
							</Form.Group>
							<Form.Group as={Col}>
								<Form.Label>Fecha término</Form.Label>
								<Form.Control
									name="hasta"
									type="date"
									id="hasta"
									onChange={handleChange}
									required
									defaultValue={votacion?.hasta?.substr(0, 10) || ""}
								/>
							</Form.Group>
							<Form.Group as={Col}>
								<Form.Label>Hora Término</Form.Label>
								<Form.Control
									name="hasta_hora"
									id="hasta_hora"
									type="time"
									onChange={handleChange}
									required
									defaultValue={getTimeFromDate(votacion?.hasta)?.slice(0,5) || ""}
								/>
							</Form.Group>
						</Form.Row>
						<Row>
							<Col>
								<Card body>
									<h4>Candidatos</h4>
									<InputGroup className="mb-3">
										<FormControl
											id="inputCandidato"
											placeholder="Nombre Candidato"
											aria-label="Nombre Candidato"
											onChange={handleChangeCandidato}
										/>
										<InputGroup.Append>
											<Button
												variant="success"
												size="sm"
												onClick={addCandidato}
												// className="float-right mt-2"
											>
												<FontAwesomeIcon icon="plus" className="mr-2" />
												Candidato
											</Button>
										</InputGroup.Append>
									</InputGroup>
									<ListGroup>
										{candidatos?.map((x, index) => {
											return (
												<ListGroup.Item key={index} style={{ padding: 8 + "px" }}>
													<span className="">{x.nombre || x}</span>
													<FontAwesomeIcon
														icon="user-minus"
														className="float-right text-danger"
														style={{ fontSize: 24 + "px", cursor: "pointer" }}
														onClick={() => removeCandidato(x)}
													/>
												</ListGroup.Item>
											)
										})}
									</ListGroup>
								</Card>
							</Col>
							<Col>
								<Card body>
									<h4>TRICEL</h4>
									<InputGroup className="mb-3">
										<FormControl
											id="inputTricel"
											name="inputTricel"
											placeholder="Rut TRICEL 11.111.111-1"
											aria-label="Rut TRICEL"
											onChange={handleChangeTricel}
										/>
										<InputGroup.Append>
											<Button
												variant="success"
												size="sm"
												onClick={addTricel}
												// className="float-right mt-2"
											>
												<FontAwesomeIcon icon="plus" className="mr-2" />
												TRICEL
											</Button>
										</InputGroup.Append>
									</InputGroup>
									<ListGroup>
										{triceles?.map((x, index) => {
											return (
												<ListGroup.Item key={index} style={{ padding: 8 + "px" }}>
													<span className="">{x.nombre || x}</span>
													<FontAwesomeIcon
														icon="user-minus"
														className="float-right text-danger"
														style={{ fontSize: 24 + "px", cursor: "pointer" }}
														onClick={() => removeTricel(x)}
													/>
												</ListGroup.Item>
											)
										})}
									</ListGroup>
								</Card>
							</Col>
						</Row>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{loader ? (
						<Loader />
					) : (
						<Fragment>
							<Button
								variant="secondary"
								disabled={loader}
								onClick={() => {
									closeModal()
								}}
							>
								Volver
							</Button>
							<Button disabled={loader} variant="primary" type="submit">
								Guardar
							</Button>
						</Fragment>
					)}
				</Modal.Footer>
			</Form>
		</Modal>
	)
}

export default ModalFormPeriodo
